import { UserProfileMinimal } from './user.interface';
import { BankDetails } from './business.interface';

export interface BankInfo {
  bank: string;
  branch: string;
  acc_name: string;
  acc_type: string;
  acc_number: string;
}

export interface FundAccountInfo {
  fund_amt_min?: string;
  physical_account: BankInfo;
  physical_balance: string;
  physical_eft_ref: string;
  virtual_account: BankInfo;
  virtual_balance: string;
  virtual_eft_ref: string;
}

export interface WithdrawalRequest {
  amount: string;
}

export interface Withdrawal extends WithdrawalRequest {
  id: number;
  biz: number;
  created: string;
  updated: string;
  requester: UserProfileMinimal;
  bank_details: BankDetails;
  approver?: UserProfileMinimal | null;
  approved?: string | null;
  status: WithdrawStatusLabel;
}

export enum WithdrawStatusLabel {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  EXPIRED = 'Expired',
  CANCELLED = 'Cancelled',
  PROCESSED = 'Processed',
}

export enum WithdrawStatus {
  Pending = 0,
  Approved = 1,
  Expired = 2,
  Cancelled = 3,
  Processed = 4,
}
